import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "snapchat.cdp.cof";
export interface DiscoverFeedSignals {
    discoverFeedSectionCacheInfo: DiscoverFeedSignals_DiscoverFeedSectionCacheInfo | undefined;
}
export interface DiscoverFeedSignals_DiscoverFeedSectionCacheInfo {
    feedType: number;
}
function createBaseDiscoverFeedSignals(): DiscoverFeedSignals {
    return { discoverFeedSectionCacheInfo: undefined };
}
export const DiscoverFeedSignals: MessageFns<DiscoverFeedSignals> = {
    encode(message: DiscoverFeedSignals, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.discoverFeedSectionCacheInfo !== undefined) {
            DiscoverFeedSignals_DiscoverFeedSectionCacheInfo.encode(message.discoverFeedSectionCacheInfo, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): DiscoverFeedSignals {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDiscoverFeedSignals();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.discoverFeedSectionCacheInfo = DiscoverFeedSignals_DiscoverFeedSectionCacheInfo.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<DiscoverFeedSignals>, I>>(base?: I): DiscoverFeedSignals {
        return DiscoverFeedSignals.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<DiscoverFeedSignals>, I>>(object: I): DiscoverFeedSignals {
        const message = createBaseDiscoverFeedSignals();
        message.discoverFeedSectionCacheInfo =
            (object.discoverFeedSectionCacheInfo !== undefined && object.discoverFeedSectionCacheInfo !== null)
                ? DiscoverFeedSignals_DiscoverFeedSectionCacheInfo.fromPartial(object.discoverFeedSectionCacheInfo)
                : undefined;
        return message;
    },
};
function createBaseDiscoverFeedSignals_DiscoverFeedSectionCacheInfo(): DiscoverFeedSignals_DiscoverFeedSectionCacheInfo {
    return { feedType: 0 };
}
export const DiscoverFeedSignals_DiscoverFeedSectionCacheInfo: MessageFns<DiscoverFeedSignals_DiscoverFeedSectionCacheInfo> = {
    encode(message: DiscoverFeedSignals_DiscoverFeedSectionCacheInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        if (message.feedType !== 0) {
            writer.uint32(8).int32(message.feedType);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): DiscoverFeedSignals_DiscoverFeedSectionCacheInfo {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDiscoverFeedSignals_DiscoverFeedSectionCacheInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.feedType = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<DiscoverFeedSignals_DiscoverFeedSectionCacheInfo>, I>>(base?: I): DiscoverFeedSignals_DiscoverFeedSectionCacheInfo {
        return DiscoverFeedSignals_DiscoverFeedSectionCacheInfo.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<DiscoverFeedSignals_DiscoverFeedSectionCacheInfo>, I>>(object: I): DiscoverFeedSignals_DiscoverFeedSectionCacheInfo {
        const message = createBaseDiscoverFeedSignals_DiscoverFeedSectionCacheInfo();
        message.feedType = object.feedType ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
